import { template as _$template } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { use as _$use } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class=audio-viewer__status>Decoding waveform…`),
  _tmpl$2 = /*#__PURE__*/_$template(`<p class="audio-viewer__status audio-viewer__status--error">Waveform unavailable: `),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=audio-viewer><audio class=audio-viewer__player controls preload=metadata></audio><canvas class=audio-viewer__waveform width=600 height=80>`);
import { createEffect, createResource, Show } from "solid-js";
import { computePeaks, drawPeaks } from "../waveform.ts";
const PEAK_BUCKETS = 600;
const WAVEFORM_COLOR = "#7dd3fc";

/** `AudioContext` isn't available in headless test/CI contexts (bun:test has no DOM at all) — feature-detect, same pattern as `ModelViewer.tsx`'s `hasWebGpu`. */
function hasAudioContext() {
  return typeof window !== "undefined" && typeof window.AudioContext === "function";
}

/** Fetches, decodes, and downsamples a baked OGG's first channel into a peak strip. Resolves `undefined` (no error) when WebAudio isn't available. */
async function loadWaveform(path) {
  if (!hasAudioContext()) return undefined;
  const response = await fetch(`/baked/${path}`);
  if (!response.ok) {
    throw new Error(`failed to load audio ${path}: ${response.status} ${response.statusText}`);
  }
  const arrayBuffer = await response.arrayBuffer();
  const context = new AudioContext();
  try {
    const audioBuffer = await context.decodeAudioData(arrayBuffer);
    return computePeaks(audioBuffer.getChannelData(0), PEAK_BUCKETS);
  } finally {
    await context.close();
  }
}

/**
 * Baked music/sfx OGG playback: a plain HTML5 `<audio controls>` element
 * (served from `/baked/<path>`, same static route every other baked asset
 * uses) plus a canvas peak-strip waveform decoded client-side via WebAudio.
 * The waveform is best-effort — `loadWaveform` never throws just because
 * `AudioContext` is missing, so this pane still renders cleanly (audio
 * player included) in a headless context with no WebAudio support.
 */
export function AudioViewer(props) {
  const [peaks] = createResource(() => props.entry.path, loadWaveform);
  let canvasRef;
  const src = () => `/baked/${props.entry.path}`;
  createEffect(() => {
    const data = peaks();
    if (!data || !canvasRef) return;
    const ctx = canvasRef.getContext("2d");
    if (!ctx) return;
    drawPeaks(ctx, data, canvasRef.width, canvasRef.height, WAVEFORM_COLOR);
  });
  return (() => {
    var _el$ = _tmpl$3(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.nextSibling;
    var _ref$ = canvasRef;
    typeof _ref$ === "function" ? _$use(_ref$, _el$3) : canvasRef = _el$3;
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return peaks.loading;
      },
      get children() {
        return _tmpl$();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return peaks.error;
      },
      get children() {
        var _el$5 = _tmpl$2(),
          _el$6 = _el$5.firstChild;
        _$insert(_el$5, () => String(peaks.error), null);
        return _el$5;
      }
    }), null);
    _$effect(() => _$setAttribute(_el$2, "src", src()));
    return _el$;
  })();
}